export const enum FeatureFlag {
  ENABLE_CADASTRAL_CHANGE_PHONE = 'enableCadastralChange',
  ENABLE_CADASTRAL_CHANGE_ADDRESS = 'enableCadastralChangeAdrress',
  ENABLE_CADASTRAL_CHANGE_EMAIL = 'enableCadastralChangeEmail',
  SHOW_TRACKING_BUTTON = 'showTrackingButton',
  PROFILE = 'selfServiceProfile',
  LOYALTY_INCENTIVE_CAMPAIGN = 'loyaltyIncentiveCampaign',
  LOYALTY_INCENTIVE_CAMPAIGN_RANKING = 'loyaltyIncentiveCampaignRanking',
  LOYALTY_INCENTIVE_CAMPAIGN_CONTENT = 'loyaltyIncentiveCampaignContent',
  LOYALTY_INCENTIVE_CAMPAIGN_CHALLENGE = 'loyaltyIncentiveCampaignChallenge',
  ENABLE_VDF_PAYMENT = 'enableVdfPayment',
}
